export enum OfferStatus {
  OPEN = 0,
  READONLY = 1,
  CLOSED = 2
}
